/* Carrinho Pele Rara: barra de metas (frete grátis e kit de sachês) e cupom na gaveta. */
(function () {
  function money(cents) {
    var fmt = (window.theme && window.theme.settings && window.theme.settings.money_format) || 'R$ {{amount_with_comma_separator}}';
    if (typeof formatMoney === 'function') return formatMoney(cents, fmt);
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  if (!customElements.get('pr-cart-progress')) {
    customElements.define('pr-cart-progress', class extends HTMLElement {
      connectedCallback() { this.render(); setTimeout(this.render.bind(this), 50); }
      render() {
        var total = parseInt(this.dataset.total, 10) || 0;
        var t1 = parseInt(this.dataset.t1, 10) || 0;
        var t2 = parseInt(this.dataset.t2, 10) || 0;
        var goal = t2 || t1;
        var gift = this.dataset.giftLabel || 'kit de sachês';
        var msg = this.querySelector('[data-msg]');
        var fill = this.querySelector('[data-fill]');
        var pct = Math.min(100, goal ? (total / goal) * 100 : 0);
        var text;
        if (total < t1) {
          text = 'Faltam <b>' + money(t1 - total) + '</b> para o frete grátis';
        } else if (t2 && total < t2) {
          text = 'Frete grátis garantido. Faltam <b>' + money(t2 - total) + '</b> para o ' + gift;
        } else if (t2) {
          text = 'Frete grátis e ' + gift + ' garantidos';
        } else {
          text = 'Frete grátis garantido';
        }
        if (msg) {
          if (msg.innerHTML !== text) msg.innerHTML = text;
          msg.classList.toggle('is-done', total >= goal);
        }
        if (fill && fill.style.width !== pct + '%') fill.style.width = pct + '%';
        this.querySelectorAll('[data-mark], [data-legend]').forEach(function (el) {
          var n = el.dataset.mark || el.dataset.legend;
          el.classList.toggle('is-on', n === '1' ? total >= t1 : total >= t2);
        });
      }
    });
  }

  function renderAllProgress() {
    document.querySelectorAll('pr-cart-progress').forEach(function (el) { if (typeof el.render === 'function') el.render(); });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(renderAllProgress, 300); setTimeout(renderAllProgress, 1500); });
  }
  var progressTimer = null;
  new MutationObserver(function (mutations) {
    var outside = mutations.some(function (m) { return !m.target.closest || !m.target.closest('pr-cart-progress'); });
    if (!outside || progressTimer) return;
    progressTimer = setTimeout(function () { progressTimer = null; renderAllProgress(); }, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function refreshDrawer() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pr-cart-coupon' });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      fetch(window.routes.cart_url + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.drawer__inner');
          var cur = drawer.querySelector('.drawer__inner');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
    } else {
      window.location.reload();
    }
  }

  function applyCoupon(form) {
    var input = form.querySelector('input');
    var btn = form.querySelector('button');
    var out = form.parentNode.querySelector('.pr-coupon__msg');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) return;
    btn.disabled = true;
    fetch(window.routes.cart_update_url || '/cart/update.js', Object.assign(fetchConfig('json'), { body: JSON.stringify({ discount: code }) }))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code && d.applicable; });
        if (!ok) {
          if (out) { out.textContent = 'Cupom inválido ou não aplicável a este carrinho.'; out.className = 'pr-coupon__msg is-err'; }
          btn.disabled = false;
          return;
        }
        if (out) { out.textContent = 'Cupom ' + code + ' aplicado.'; out.className = 'pr-coupon__msg is-ok'; }
        refreshDrawer();
      })
      .catch(function () {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
  }

  function removeCoupon() {
    fetch(window.routes.cart_update_url || '/cart/update.js', Object.assign(fetchConfig('json'), { body: JSON.stringify({ discount: '' }) }))
      .then(function () { refreshDrawer(); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.pr-coupon');
    if (!form) return;
    e.preventDefault();
    applyCoupon(form);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pr-coupon-remove]');
    if (!b) return;
    e.preventDefault();
    removeCoupon();
  });
})();
